module.exports = __webpack_public_path__ + "icon-close.svg?21d7e5df9f58e695bc73185cb2568dce";